const galleryId = 47;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_1079119931.jpg","sh_1670109205.jpg","sh_1832805082.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Zirconium vs. PFM'));

group = ["sh_1396865237.jpg","sh_744541756.jpg","sh_767861803.jpg","sh_1082449385.jpg","sh_1673668807.jpg","sh_1741122443.jpg","sh_428431477.jpg","sh_744541786.jpg","sh_1159729318.jpg"];
group.forEach((i) => addItemToGroup(i, '2. implant crown vs. bridge'));

group = ["sh_85691473.jpg","sh_85691464.jpg","sh_81081196.jpg","sh_610380740.jpg","sh_1522470902.jpg","sh_343850504.jpg","sh_1137607676.jpg","sh_1807510093.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Various images'));

group = ["sh_1047275122.jpg","sh_1780050494.jpg","sh_1824119021.jpg","sh_1844754238.jpg","sh_1844754247.jpg","sh_1844754253.jpg","sh_1845627451.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

export default items;
